export const toLabel = wcardinal.ui.toLabel;